import { render, staticRenderFns } from "./OnboardingGroupEdit.vue?vue&type=template&id=09239bd4"
import script from "./OnboardingGroupEdit.js?vue&type=script&lang=js&external"
export * from "./OnboardingGroupEdit.js?vue&type=script&lang=js&external"
import style0 from "./OnboardingGroupEdit.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports